import type { SVGProps } from 'react';

export function IcecreamIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 7.765a.034.034 0 0 1-.034-.038A6 6 0 0 0 18 7.088C18 3.727 15.313 1 12 1 8.688 1 6 3.727 6 7.088q0 .323.033.64A.034.034 0 0 1 6 7.764c-1.104 0-2 .909-2 2.03s.896 2.028 2 2.028h12c1.104 0 2-.909 2-2.029s-.896-2.03-2-2.03m-9.773 6.088a1 1 0 0 0-.909 1.418l3.732 8.116c.17.372.542.613.95.613s.775-.241.95-.613l3.732-8.116a1 1 0 0 0-.909-1.418z" />
    </svg>
  );
}
